import {ViolationTargetFragment} from '../../../../gql/graphql';
import {ViolationOtherTargetModel} from './ViolationOtherTargetModel.model';
import {ViolationLineItemTargetModel} from './ViolationLineItemTargetModel.model';

export class ViolationTargetModel {
  public lineItemTarget?: ViolationLineItemTargetModel;
  public otherTarget?: ViolationOtherTargetModel;

  constructor(params: ViolationTargetModel) {
    this.lineItemTarget = params.lineItemTarget;
    this.otherTarget = params.otherTarget;
  }

  public static fromCheckoutV1(target?: ViolationTargetFragment | null) {
    /* istanbul ignore next */
    if (!target) {
      return undefined;
    }

    return new ViolationTargetModel({
      lineItemTarget: ViolationLineItemTargetModel.fromCheckoutV1(target.lineItem),
      otherTarget: ViolationOtherTargetModel.fromCheckoutV1(target.other),
    });
  }
}
